import { all } from 'redux-saga/effects';
import alertRulesSaga from './alertRules';

export default function* settingsModuleSaga() {
  yield all([alertRulesSaga()]);
}
